import { defineStore } from 'pinia'
import { store } from '../index'
import type { ButtonType } from 'element-plus'

interface FooterList {
  name?: string
  type?: ButtonType
  icon?: any
  loading?: boolean
  callback?: () => void
}

interface FooterState {
  btnList?: FooterList[]
  btnStr?: string
}

export const useUserStore = defineStore('footer', {
  state: (): FooterState => {
    return {
      btnList: [],
      btnStr: ''
    }
  },
  getters: {
    getList(): FooterList[] {
      return this.btnList ? this.btnList : []
    },
    getBtnStr(): string {
      return this.btnStr ? this.btnStr : ''
    }
  },
  actions: {
    setBtnList(btnList: FooterList[]) {
      this.btnList = btnList
    },
    setBtnStr(btnStr: string) {
      this.btnStr = btnStr
    }
  },
  persist: true
})

export const useFooter = () => {
  return useUserStore(store)
}
